import { NavLink } from 'react-router-dom';
import { ReportPrimaryTypes } from './types';
import ROUTES from '../../../routes';
import formatReportBalance from '../../../hoc/helpers/format-report-balance';

import cn from './reports.module.css';

const ReportPrimary = ({
  primary,
  categoryId,
  groupId,
  withRoute,
  accountType,
  search,
  fromPath,
  type,
}: ReportPrimaryTypes) => {
  const isZeroRow =
    Number(primary.total.debitIn) +
      Number(primary.total.creditIn) +
      Number(primary.total.debitTo) +
      Number(primary.total.creditTo) +
      Number(primary.total.debitOut) +
      Number(primary.total.creditOut) ===
    0;

  let reportLink = '';

  if (type === 'balance') {
    reportLink = ROUTES.REPORTS_BALANCE_SHEET;
  } else if (type === 'profit-loss') {
    reportLink = ROUTES.REPORTS_PROFIT_lOSS_SHEET;
  } else if (type === 'safeguarding') {
    reportLink = ROUTES.REPORTS_SAFEGUARDING;
  } else if (type === 'capital-adequacy') {
    reportLink = ROUTES.REPORTS_CAPITAL_ADEQUACY;
  } else if (type === 'banks') {
    reportLink = ROUTES.REPORTS_BANK_AND_PSP;
  }

  return (
    <NavLink
      className={`${cn.reportPrimary} ${
        withRoute ? cn.reportPrimaryCursorPointer : ''
      }
    ${isZeroRow ? cn.reportPrimaryGreyRow : ''}`}
      to={`${ROUTES.REPORTS_ACCOUNTS_BALANCE}${
        search ? `${search}&` : '?'
      }categoryId=${categoryId}&groupId=${groupId}&primaryId=${primary.id}`}
      state={{ from: `${fromPath}${search || ''}` }}
      onClick={() => localStorage.setItem('reportLink', reportLink)}
    >
      <div className={`${cn.reportPrimaryValue} ${cn.reportPrimaryName}`}>
        <span className={cn.reportNumber}>{primary.number}</span>
        <span>{primary.description}</span>
      </div>
      <div className={`${cn.reportPrimaryValue} ${cn.reportPrimaryType}`}>
        {accountType && <span>{accountType}</span>}
      </div>
      <div className={cn.reportPrimaryValue}>
        <span>{formatReportBalance(primary.total.debitIn)}</span>
      </div>
      <div className={cn.reportPrimaryValue}>
        <span>{formatReportBalance(primary.total.creditIn)}</span>
      </div>
      <div className={cn.reportPrimaryValue}>
        <span>{formatReportBalance(primary.total.debitTo)}</span>
      </div>
      <div className={cn.reportPrimaryValue}>
        <span>{formatReportBalance(primary.total.creditTo)}</span>
      </div>
      <div className={cn.reportPrimaryValue}>
        <span>{formatReportBalance(primary.total.debitOut)}</span>
      </div>
      <div className={cn.reportPrimaryValue}>
        <span>{formatReportBalance(primary.total.creditOut)}</span>
      </div>
    </NavLink>
  );
};

export default ReportPrimary;
